import { odataFetch } from "@/lib/odata-fetch";
import {
  qEXDSOpLandingDocumentList,
  QEXDSOpLandingDocumentList,
} from "@/odata/appu4dm/QAppU4DM";
import { createQueryBuilderV4 } from "@odata2ts/odata-query-builder";
import { EXDSOpLandingDocumentList } from "@/odata/appu4dm/AppU4DMModel";
import { useWorkOrderOperationId } from "../work-order/use-work-order-operation-id";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { documentsKeys } from "./documents-keys";

export const getDocumentsQueryOptions = (wooId: string | undefined | null) =>
  queryOptions({
    queryKey: documentsKeys.get(wooId),
    queryFn: ({ meta }) => fetchDocuments(wooId!, meta!.token!),
    enabled: ({ meta }) => !!(wooId && meta?.token),
    select: (data) =>
      data?.value.filter(
        (doc, index, docs) =>
          index ===
          docs.findIndex(
            (x) => x.Document === doc.Document && x.Category === doc.Category
          )
      ),
  });

export function useDocuments() {
  const { workOrderOperationId } = useWorkOrderOperationId();
  const wooId = workOrderOperationId?.WorkOrderOperation_Id;

  const { data, ...query } = useQuery(getDocumentsQueryOptions(wooId));

  return {
    documents: data,
    ...query,
  };
}

async function fetchDocuments(workOrderOperationId: string, token: string) {
  const builder = createQueryBuilderV4(
    "EXDSOpLandingDocumentList",
    new QEXDSOpLandingDocumentList()
  ).filter(
    qEXDSOpLandingDocumentList.WorkOrderOperation.equals(
      workOrderOperationId
    ).and(qEXDSOpLandingDocumentList.ExecutionGroupPhase.isNull())
  );

  return odataFetch<EXDSOpLandingDocumentList>({ builder, token });
}
